<template>
  <div v-parallax-fit="parallax" class="photo" id="photo-1">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/10_cat.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 3800,
          end: 5000,
          fromStyle: { transform: 'translateY(-300%) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(0%) rotateZ(3deg)' },
          easing: 'linear'
        },
        {
          start: 7000,
          end: 8000,
          fromStyle: { transform: 'translateY(0%) rotateZ(3deg)' },
          toStyle: { transform: 'translateY(300%) rotateZ(3deg)' },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.transform == 'translateY(0%) rotateZ(3deg)') {
          self.$evidence.value = null;
          self.$readMore.value = '';
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#photo-1'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.photo {
  position: absolute;
  bottom: -8%;
  left: -11%;
  z-index: 2;
  max-width: 500px;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1600px) {
  .photo {
    max-width: 400px;
  }
}

@media screen and (max-width: 1024px) {
  .photo {
    max-width: 350px;
  }
}

@media screen and (max-width: 650px) {
  .photo {
    max-width: 200px;
    left: -5%;
  }
}
</style>
